import { useNavigate } from 'react-router-dom';

export const fmtDate = (v) => {
  if (!v) return '-';
  try {
    const d = new Date(v + 'T00:00:00');
    const day = d.toLocaleDateString('en-US', { weekday: 'short' });
    return `${day}, ${d.getMonth()+1}/${d.getDate()}`;
  } catch { return v; }
};

export const fmtMoney = (v) => v != null ? `$${Math.round(v).toLocaleString()}` : '-';

export const cardBase = "bg-white rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.08)] border-0";
export const thClass = "text-[11px] font-semibold uppercase tracking-wider text-gray-400 px-4 py-2.5 text-left";
export const tdClass = "px-4 py-2.5 text-[13px]";
export const rowClass = "border-b border-gray-100 last:border-0 hover:bg-gray-50/60 transition-colors";

export function ViewAllLink({ to, label }) {
  const navigate = useNavigate();
  return (
    <button onClick={() => navigate(to)} className="text-[11px] text-emerald-600 hover:text-emerald-700 hover:underline font-semibold tracking-wide uppercase" data-testid={`view-all-${label}`}>
      View All
    </button>
  );
}
